// Validação de CPF
export const isValidCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]/g, '')
  
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false
  
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i)
  }
  let remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(cpf.charAt(9))) return false
  
  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i)
  }
  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  
  return remainder === parseInt(cpf.charAt(10))
}

// Validação de CNPJ
export const isValidCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]/g, '')
  
  if (cnpj.length !== 14) return false
  
  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  
  let sum = 0
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cnpj.charAt(i)) * weights1[i]
  }
  let remainder = sum % 11
  const digit1 = remainder < 2 ? 0 : 11 - remainder
  
  if (digit1 !== parseInt(cnpj.charAt(12))) return false
  
  sum = 0
  for (let i = 0; i < 13; i++) {
    sum += parseInt(cnpj.charAt(i)) * weights2[i]
  }
  remainder = sum % 11
  const digit2 = remainder < 2 ? 0 : 11 - remainder
  
  return digit2 === parseInt(cnpj.charAt(13))
}

// Validar CPF ou CNPJ
export const isValidCpfCnpj = (value) => {
  const numbers = value.replace(/[^\d]/g, '')
  
  if (numbers.length === 11) {
    return isValidCPF(numbers)
  } else if (numbers.length === 14) {
    return isValidCNPJ(numbers)
  }
  
  return false
}

// Buscar CEP (ViaCEP primário, OpenCEP fallback)
export const fetchCEP = async (cep) => {
  const cleanCep = cep.replace(/[^\d]/g, '')
  if (cleanCep.length !== 8) return null

  // Primário: ViaCEP
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`)
    const data = await response.json()
    if (!data.erro) {
      return {
        endereco: data.logradouro,
        bairro: data.bairro,
        cidade: data.localidade,
        estado: data.uf
      }
    }
  } catch {
    console.warn('ViaCEP falhou, tentando OpenCEP...')
  }

  // Fallback: OpenCEP
  try {
    const response = await fetch(`https://opencep.com/v1/${cleanCep}`)
    const data = await response.json()
    if (data.cep) {
      return {
        endereco: data.logradouro,
        bairro: data.bairro,
        cidade: data.localidade,
        estado: data.uf
      }
    }
  } catch (err) {
    console.error('OpenCEP também falhou:', err)
  }

  return null
}

// Buscar CNPJ via BrasilAPI (suporta CORS)
export const fetchCNPJ = async (cnpj) => {
  const cleanCnpj = cnpj.replace(/[^\d]/g, '')
  if (cleanCnpj.length !== 14) return null

  try {
    const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cleanCnpj}`)
    if (!response.ok) return null
    const data = await response.json()

    // Formatar telefone
    let telefone = ''
    if (data.ddd_telefone_1) {
      const raw = data.ddd_telefone_1.replace(/[^\d]/g, '')
      telefone = raw.length >= 10
        ? `(${raw.substring(0, 2)}) ${raw.substring(2, raw.length - 4)}-${raw.substring(raw.length - 4)}`
        : raw
    }

    return {
      nome: data.razao_social || '',
      email: data.email || '',
      telefone,
      endereco: data.logradouro || '',
      numero: data.numero || '',
      complemento: data.complemento || '',
      bairro: data.bairro || '',
      cidade: data.municipio || '',
      estado: data.uf || '',
      cep: data.cep?.replace(/[^\d]/g, '') || '',
      situacao: data.descricao_situacao_cadastral || ''  // ATIVA, BAIXADA, SUSPENSA, INAPTA
    }
  } catch (err) {
    console.error('Erro ao buscar CNPJ:', err)
    return null
  }
}